<template>
  <div class="mypage-ec-site-connect-complete-parts">
    <h3 class="mypage-ec-site-connect-complete-parts__title">
      {{ $tc('MypagePage.MypageEcSiteConnectPage.complete.title') }}
    </h3>
    <p class="mypage-ec-site-connect-complete-parts__description">
      {{ $tc('MypagePage.MypageEcSiteConnectPage.complete.description') }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MypageEcSiteConnectCompleteParts',
})
</script>

<style scoped lang="scss">
.mypage-ec-site-connect-complete-parts {
  color: $gray75;

  &__title {
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 0.04em;
  }

  &__description {
    margin-top: 12px;
    font-size: 13px;
    letter-spacing: 0.04em;
    white-space: pre-wrap;
  }
}
</style>
